import React from 'react';
import MUITextField from '@material-ui/core/TextField';
import { InputStyle } from './Input.module.scss';

const Input = ({ type='text', errors=null, value='', ...props}) => <MUITextField type={type} inputProps={props.array !== undefined ? {arrayid:props.array} : {}} className={InputStyle} fullWidth error={errors ? true : false} helperText={errors ? errors : false} variant="outlined" margin="dense" autoComplete="off" color="primary" size={props.size} value={value} {...props} />

export default Input;